var map = {
	"./Symbol_0.png": "be83",
	"./Symbol_1.png": "52bde",
	"./Symbol_2.png": "ce8c",
	"./Symbol_3.png": "eb677",
	"./Symbol_4.png": "e821",
	"./Symbol_5.png": "4adc",
	"./Symbol_6.png": "6345",
	"./Symbol_7.png": "618d",
	"./Symbol_8.png": "9805",
	"./Symbol_9.png": "0dd5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70cf";